import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export const downloadExampleExcel = async (templateVariables = []) => {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Contactos");

  // Build header columns: Teléfono + templateVariables
  const headers = ["Teléfono", ...templateVariables];

  // Add header row
  const headerRow = sheet.addRow(headers);

  // Style header row: bold + light green background
  headerRow.eachCell((cell) => {
    cell.font = { bold: true };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFE2EFDA" },
    };
  });

  // Add example rows
  const exampleRow1 = [
    "525512345678",
    ...templateVariables.map((variable) => `Ejemplo ${variable}`),
  ];

  const exampleRow2 = [
    "5215551234567",
    ...templateVariables.map((variable) => `Ejemplo ${variable}`),
  ];

  sheet.addRow(exampleRow1);
  sheet.addRow(exampleRow2);

  // Auto-width columns based on content
  sheet.columns.forEach((column, index) => {
    const header = headers[index] || "";
    const maxLength = Math.max(
      header.length,
      exampleRow1[index] ? String(exampleRow1[index]).length : 0,
      exampleRow2[index] ? String(exampleRow2[index]).length : 0,
      10,
    );
    column.width = maxLength + 2;
  });

  // Generate and download the file
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, "ejemplo_contactos.xlsx");
};
